Vue.component('packs', {
  template: templates.packs,
  data() {
    return {
      model: {
        edit: false,
        pack: {
          id: null,
          name: null,
          size: 0,
          ultraChance: 0,
          legendaryChance: 0,
          ultimateChance: 0,
          ultraGuaranteed: false,
          legendaryGuaranteed: false,
          limit: 0,
          active: false
        },
        packs: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
          c.$root.$emit('getPacks', data);
          c.$root.$emit('unlockPacks', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.packs[`${id}`];

      if (id == c.model.pack.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.pack = {
        id: id,
        name: data.name,
        size: data.size,
        limit: data.limit,
        ultraChance: data.ultraChance,
        legendaryChance: data.legendaryChance,
        ultimateChance: data.ultimateChance,
        ultraGuaranteed: data.ultraGuaranteed,
        legendaryGuaranteed: data.legendaryGuaranteed,
        active: data.active
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.pack;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (data.active && data.size == 0) {
        utils.alert.error('The pack must have at least one card to be activated.');
        return;
      }
      
      packService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.packs[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.packs[`${data.id}`] = data;
          }

          c.reset();
          
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      
      c.model.pack = {
        id: null,
        name: null,
        size: null,
        limit: 0,
        ultraChance: 0,
        legendaryChance: 0,
        ultimateChance: 0,
        ultraGuaranteed: false,
        legendaryGuaranteed: false,
        active: false
      }
    }
  }
});